<div
  *transloco="let t; read: 'action-plan-details-progress-tab'"
  class="action-plan-details-progress-tab__container"
>
  <app-progress-widget>
    <span title>{{ t('item-progress-title') }}</span>

    <xi-icon-button actions color="CX" icon="kabob" [disabled]="true"></xi-icon-button>

    <app-status-progress-view [actionPlan]="actionPlan" mode="item"></app-status-progress-view>
  </app-progress-widget>

  <app-progress-widget>
    <span title>{{ t('task-progress-title') }}</span>

    <xi-icon-button actions color="CX" icon="kabob" [disabled]="true"></xi-icon-button>

    <app-status-progress-view [actionPlan]="actionPlan" mode="task"></app-status-progress-view>
  </app-progress-widget>
</div>
